import { gql } from "@apollo/client";

export const CREATE_CONTINUUM_LICENSE = gql`
  mutation CreateContinuumLicense($data: CreateContinuumLicenseInputType!) {
    createContinuumLicense(data: $data) {
      licenseId
      email
      customerName
      jiraTicket
      serviceDeskID
      department
      licenseType
      licenseCategory
      platformEffectiveDate
      platformExpiryDate
      modernizationAllowed
      linesOfCode
      carryOverLOC
      continuumCarryover
      licenseStatus
    }
  }
`;

export const CREATE_SCANNER_LICENSE = gql`
  mutation CreateScannerLicense($data: CreateScannerLicenseInputType!) {
    createScannerLicense(data: $data) {
      licenseId
      email
      customerName
      jiraTicket
      serviceDeskID
      department
      licenseType
      scannerEffectiveDate
      scannerExpiryDate
      licenseStatus
    }
  }
`;

export const MUTATION_APPROVE_CONTINUUM_LICENSE = gql`
  mutation ApproveContinuumLicense($id: Float!) {
    approveContinuumLicense(id: $id) {
      id
      licenseStatus
      approvedBy
    }
  }
`;

export const MUTATION_DECLINE_CONTINUUM_LICENSE = gql`
  mutation DeclineContinuumLicense($id: Float!, $declineReason: String!) {
    declineContinuumLicense(id: $id, declineReason: $declineReason) {
      id
      licenseStatus
      denialReason
      approvedBy
    }
  }
`;

export const ACTIVATE_MACHINE = gql`
  mutation ActivateMachine(
    $licenseId: String!
    $machineFingerprint: String!
    $activationEmail: String!
    $previousLicenseId: String
    $reportedLinesUsed: Float
    $reportedEffectiveLimit: Float
  ) {
    activateMachine(
      licenseId: $licenseId
      machineFingerprint: $machineFingerprint
      activationEmail: $activationEmail
      previousLicenseId: $previousLicenseId
      reportedLinesUsed: $reportedLinesUsed
      reportedEffectiveLimit: $reportedEffectiveLimit
    ) {
      id
      licenseId
      machineId
      activationKey
      generatedAt
      expiryDate
      activatedByEmail
    }
  }
`;

export const REQUEST_DEACTIVATION = gql`
  mutation RequestDeactivation($licenseId: String!) {
    requestDeactivation(licenseId: $licenseId) {
      id
      licenseId
      machineId
      deactivationKey
      deactivationRequestId
      issuedAt
      expiresAt
    }
  }
`;

export const CONFIRM_DEACTIVATION = gql`
  mutation ConfirmDeactivation(
    $licenseId: String!
    $deactivationConfirmationPayload: String!
  ) {
    confirmDeactivation(
      licenseId: $licenseId
      deactivationConfirmationPayload: $deactivationConfirmationPayload
    ) {
      id
      licenseId
      machineFingerprint
      status
      deactivatedAt
      deactivatedByEmail
    }
  }
`;
